export const filterArray = [
    {
        name:"Municipality",
        id:1,

    },
 
    
  ]